import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceHappy12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFaceHappy12Filled"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FaceHappy12Filled)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M3.75 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.919 7.034a.5.5 0 0 1 .646.281l.001.004.016.033q.021.049.079.143c.076.123.198.292.38.461.354.331.953.687 1.934.687s1.58-.356 1.935-.687a2.3 2.3 0 0 0 .458-.604l.016-.033.001-.004a.5.5 0 0 1 .931.366L8.85 7.5l.466.182-.001.002-.001.003-.003.008-.01.023-.033.071q-.042.09-.127.23c-.114.184-.29.426-.548.668-.525.49-1.363.956-2.618.956s-2.093-.466-2.618-.956a3.3 3.3 0 0 1-.548-.668 3 3 0 0 1-.16-.301l-.01-.023-.003-.008-.001-.003v-.002L3.1 7.5l-.466.181a.5.5 0 0 1 .285-.647"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="FaceHappy12Filled">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFaceHappy12Filled);
